var exports = {
  "N": "pusherAvatar__jVsowc",
  "W": "pusherLink__7Q3JnW",
};

module.exports = exports;
